/**
 * useFeature — React hook for feature-flag gating.
 *
 * The backend resolves per-user features (user override → tenant override →
 * registry default) and returns them on /auth/login + /auth/verify under
 * `user.features`. This hook reads the resolved map from auth state.
 *
 * Usage:
 *   if (!useFeature('agents.behavior_switching')) return null;
 *   <ModeSelector />
 */

import { useAuth } from '@/hooks/useAuth';

export function useFeature(key: string): boolean {
  const { user } = useAuth();
  return user?.features?.[key] === true;
}
